import { formattedDatePtBr } from '@utils/dates/formattedDatePtBr'

import type { PeriodSelectedDataProps } from '@pages/Preview/context/types'
import type { AdjustPreviewFormProps } from './types'

export const setInitialValues = (
  data?: PeriodSelectedDataProps | null,
  currentWeekNumber?: number
) => {
  const weekNumber = currentWeekNumber ?? 0
  const weekLabel = weekNumber > 0 ? `Semana ${weekNumber}` : ''

  const parsedData: AdjustPreviewFormProps = {
    period: data?.competencePeriod?.label || '',
    dateCompetence: data?.competenceDate ? formattedDatePtBr(data.competenceDate) : '',
    week: weekLabel,
    weekNumber,
    accounts: [
      {
        account: '',
        accountId: '',
        adjustmentValue: '',
        observations: ''
      }
    ]
  }

  return parsedData
}
